import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import React from 'react'
import { List, Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import {
  CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED,
  CHECKOUT_ORDER_ERROR_TYPE_PAYMENT,
  CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE,
} from '../../../services/checkout/index'
import { PAYMENT_ERROR_TYPE_POSTAL_CODE } from '../../../services/payment/index'
import { getPrimary } from '../../../services/languages/index'
import { getCancelAccountHelpUrl, getHelpCenterUrl } from '../../../services/url/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import AdyenDropIn from '../../AdyenDropIn/index'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import CartBillingProcessing from '../../CartBillingProcessing/index'
import CartOrderSummaryV2 from '../CartOrderSummaryV2/index'
import { TARGET_BLANK } from '../../Link/constants'
import { H1, HEADING_TYPES } from '../../Heading/index'
import ErrorMessage from '../../ErrorMessage/index'
import Link from '../../Link/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'

function CartPaymentPageV2 (props) {
  const {
    checkout,
    staticText,
    user = Map(),
    payment,
    plans,
  } = props
  const checkoutProcessing = checkout.get('processing')
  const checkoutOrderError = checkout.get('orderError')
  const paymentError = payment.getIn(['data', 'payments', 'success']) === false || payment.getIn(['data', 'payments', 'error']) === true
  const paymentValidationError = payment.get('error')
  const errorShouldRender = checkoutOrderError
    || (paymentError || paymentValidationError)
  const userLanguage = getPrimary(user.getIn(['data', 'language'], List()))
  const selectedPlan = plans.get('selection', Map())
  const planCost = selectedPlan.get('costs', List([0])).first()

  const renderDisclaimerCopy = () => {
    return (
      <span className="cart-payment-v2__disclaimer">
        {`${staticText.getIn(['data', 'disclaimerIntro2'])} `}
        <Link
          className="cart-payment-v2__disclaimer-link"
          directLink
          to={getCancelAccountHelpUrl(userLanguage)}
          target={TARGET_BLANK}
        >
          {`${staticText.getIn(['data', 'disclaimerLink2'])}. `}
        </Link>
      </span>
    )
  }

  const renderOrderError = () => {
    let message = staticText.getIn(['data', 'errorGeneric'])

    if (!errorShouldRender) {
      return null
    }

    if (
      checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_PAYMENT || paymentError
    ) {
      message = staticText.getIn(['data', 'errorPayment'])
    } else if (checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED) {
      message = staticText.getIn(['data', 'errorAlreadySubscribed'])
    } else if (
      checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE
      || paymentValidationError === PAYMENT_ERROR_TYPE_POSTAL_CODE
    ) {
      message = staticText.getIn(['data', 'errorPostalCode'])
    }

    const orderErrorMessages = [
      `${message} `,
      <Link
        key={getHelpCenterUrl(userLanguage)}
        className="cart-payment-v2__billing-error-link"
        to={getHelpCenterUrl(userLanguage)}
        directLink
        target={TARGET_BLANK}
      >
        {staticText.getIn(['data', 'customerSupport'])}
      </Link>,
    ]

    return (
      <ErrorMessage
        errorMessages={orderErrorMessages}
        errorMessageClass={['cart-payment-v2__billing-error']}
      />
    )
  }

  const getCheckoutIframe = () => {
    return (
      <AdyenDropIn
        submitButtonText={staticText.getIn(['data', 'startMembership'])}
        disclaimer={renderDisclaimerCopy()}
        parentProcessing={checkoutProcessing}
        error={errorShouldRender}
        planCost={planCost}
      />
    )
  }

  const getItemCheckoutProcessingClassName = (baseClassName, processing) => {
    const className = [baseClassName]

    if (processing) {
      className.push(`${baseClassName}--hidden`)
    }

    return className.join(' ')
  }

  return (
    <div className="cart-payment-v2">
      {
        checkoutProcessing
          ? <div className="cart-payment-v2__processing">
            <CartBillingProcessing finalize />
          </div>
          : null
      }
      <div className={getItemCheckoutProcessingClassName('cart-payment-v2__content', checkoutProcessing)}>
        <CartLayoutTemplate
          colOne={
            <React.Fragment>
              <CartProgressIndicator v2 />
              {
                <React.Fragment>
                  <H1 as={HEADING_TYPES.H3} className="cart-payment-v2__title cart-payment-v2__title--card">
                    {staticText.getIn(['data', 'paymentInfo'])}
                  </H1>
                  <div className="cart-payment-v2__secure-payment">
                    {staticText.getIn(['data', 'securePayment'])}
                  </div>
                </React.Fragment>
              }
              {renderOrderError()}
              {getCheckoutIframe()}
            </React.Fragment>
          }
          colTwo={
            <div className="cart-payment-v2__order-summary">
              <CartOrderSummaryV2 />
            </div>
          }
        />
      </div>
    </div>
  )
}

CartPaymentPageV2.propTypes = {
  history: PropTypes.object.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  checkout: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  plans: ImmutablePropTypes.map.isRequired,
  payment: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      checkout: state.checkout,
      user: state.user,
      auth: state.auth,
      userAccount: state.userAccount,
      plans: state.plans,
      payment: state.payment,
    }),
  ),
  connectStaticText({ storeKey: 'cartPaymentPageV2' }),
)(CartPaymentPageV2)
